const templateIndex = 'TemplateIndex';

// CREATE NEW TEMPLATE
export const CREATE_TEMPLATE_REQUEST = `${templateIndex}/CREATE_TEMPLATE_REQUEST`;
export const CREATE_TEMPLATE_RESPONSE = `${templateIndex}/CREATE_TEMPLATE_RESPONSE`;

export const COPY_TEMPLATE_REQUEST = `${templateIndex}/COPY_TEMPLATE_REQUEST`;
export const COPY_TEMPLATE_RESPONSE = `${templateIndex}/COPY_TEMPLATE_RESPONSE`;

export const GET_MESSAGETYPES_AND_SENDERS_REQUEST = `${templateIndex}/GET_MESSAGETYPES_AND_SENDERS_REQUEST`;
export const GET_MESSAGETYPES_AND_SENDERS_RESPONSE = `${templateIndex}/GET_MESSAGETYPES_AND_SENDERS_RESPONSE`;
export const GET_MESSAGETYPES_AND_SENDERS_ERROR = `${templateIndex}/GET_MESSAGETYPES_AND_SENDERS_ERROR`;

export const DELETE_TEMPLATES_REQUEST = `${templateIndex}/DELETE_TEMPLATES_REQUEST`;
export const DELETE_TEMPLATES_RESPONSE = `${templateIndex}/DELETE_TEMPLATES_RESPONSE`;

export const GET_TEMPLATE_PREVIEW_THUMBNAILS_REQUEST = `${templateIndex}/TEMPLATE_PREVIEW_THUMBNAILS_REQUEST`;
export const GET_TEMPLATE_PREVIEW_THUMBNAILS_RESPONSE = `${templateIndex}/TEMPLATE_PREVIEW_THUMBNAILS_RESPONSE`;
export const EXPORT_TEMPLATE_HTML_REQUEST = `${templateIndex}/EXPORT_TEMPLATE_HTML_REQUEST`;
export const EXPORT_TEMPLATE_HTML_RESPONSE = `${templateIndex}/EXPORT_TEMPLATE_HTML_RESPONSE`;

export const FETCH_ROOT_FOLDER_ID_RESPONSE = 'TemplateFolder/FETCH_ROOT_FOLDER_ID_RESPONSE';
export const IS_TEMPLATE_ASYNC_PROCESSING = `${templateIndex}/IS_TEMPLATE_ASYNC_PROCESSING`;
